import React from 'react';
import PricingCard from './cards/PricingCard';
import {cn} from '../lib/utils';

type PricingOption = {
    id: string;
    title: string;
    price: number;
    currency: string;
    duration: string;
    trialDuration: string;
    description: string;
    featured: boolean;
    active: boolean;
    onSelect: () => void;
    features: string[];
    hasActiveSubscription: boolean;
    isTrialSubscriptionActive: boolean;
}


type PricingOptionsListProps = {
    items: PricingOption[];
    onSelect: (option: PricingOption) => void;
}

const PricingOptionsList = ({items, onSelect}: PricingOptionsListProps) => {
    return (
        <div className="grid gap-6 lg:grid-cols-3">
            {
                items.map((p,idx) => {
                    return <div key={p.title} className={cn("[&>*]:h-full", {
                        'scale-105 ': p.featured
                    })}>
                        <PricingCard
                            key={p.id}
                            id={p.id}
                            imgSrc={idx < 3 ? `/media/plan-${idx + 1}.svg` : `/media/pricing-plan-img.svg`}
                            title={p.title}
                            price={p.price}
                            currency={p.currency}
                            duration={p.duration}
                            trialDuration={p.trialDuration}
                            description={p.description}
                            featured={p.featured}
                            active={p.active}
                            features={p.features}
                            hasActiveSubscription={p.hasActiveSubscription}
                            isTrialSubscriptionActive={p.isTrialSubscriptionActive}
                            onSelect={() => {
                                onSelect(p);
                            }}
                        />
                    </div>
                })
            }
        </div>
    )
};

export default PricingOptionsList;
